import { ReactElement } from 'react';

export const CLEAR_MODAL_CONTENT = 'CLEAR_MODAL_CONTENT';
export const SET_MODAL_CONTENT = 'SET_MODAL_CONTENT';

export interface IModalState {
  content?: ReactElement | null;
  visible: boolean;
  optionModal?: boolean;
}

export interface IActionSetModalContent {
  type: typeof SET_MODAL_CONTENT;
  content: ReactElement;
  optionModal?: boolean;
}

export interface IActionClearModalContent {
  type: typeof CLEAR_MODAL_CONTENT;
}

export type TAction = IActionClearModalContent | IActionSetModalContent;
